import { render, staticRenderFns } from "./cabinet-fl44-card-subheader.vue?vue&type=template&id=04d066c3&scoped=true&"
import script from "./cabinet-fl44-card-subheader.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-card-subheader.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl44-card-subheader.vue?vue&type=style&index=0&id=04d066c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d066c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d066c3')) {
      api.createRecord('04d066c3', component.options)
    } else {
      api.reload('04d066c3', component.options)
    }
    module.hot.accept("./cabinet-fl44-card-subheader.vue?vue&type=template&id=04d066c3&scoped=true&", function () {
      api.rerender('04d066c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-card-subheader.vue"
export default component.exports